import { createDecorator } from "vue-class-component";

export const NoCache = createDecorator((options, key) => {
	// component options should be passed to the callback
	// and update for the options object affect the component
	if (options.computed) {
		(options.computed[key] as any).cache = false;
	}
});
